import React from 'react'
import { DvLayout } from '@dv5/domain'
import './LayoutChooserList.less'

interface LayoutChooserListProps {
    layouts: DvLayout[]
    selectedLayoutId: string | undefined
    onSelect: (layout: DvLayout) => void
    highlightedLayoutIndex?: number
    onHoverLayout?: (layout: DvLayout | null) => void
}

export const LayoutChooserList: React.FC<LayoutChooserListProps> = ({
    layouts,
    selectedLayoutId,
    onSelect,
    highlightedLayoutIndex = -1,
    onHoverLayout,
}) => {
    if (layouts.length === 0) return null

    return (
        <div
            className="layout-chooser-list"
            onMouseLeave={() => onHoverLayout?.(null)}
        >
            {layouts.map((layout, index) => (
                <button
                    key={layout.id}
                    type="button"
                    className={`layout-chooser-item ${layout.id === selectedLayoutId ? 'active' : ''}${index === highlightedLayoutIndex ? ' highlighted' : ''}`}
                    aria-pressed={layout.id === selectedLayoutId}
                    aria-label={`Use ${layout.title} for navigation`}
                    onClick={() => onSelect(layout)}
                    onMouseEnter={() => onHoverLayout?.(layout)}
                >
                    <span className="layout-chooser-item-title">{layout.title}</span>
                </button>
            ))}
        </div>
    )
}
